













































import { ref, defineComponent, computed } from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';

const warrantyShopifyId = process.env.NUXT_ENV_IS_PROD === 'true' ? 'gid://shopify/Product/8588387516652' : 'gid://shopify/Product/7766283747417';

export default defineComponent({
  name: 'PDPWarrantyUpsell',
  emits: ['warrantySelected'],
  components: {
    FCImage,
  },
  setup(_props, { emit }) {
    // @ts-ignore
    const { $store } = useNuxtApp();
    const warranty = computed(() => {
      const product = $store.getters.productsCollection?.find((item) => item.id === warrantyShopifyId);

      return {
        id: product.variants[0].id,
        title: product.title,
        description: product.description,
        image: product.images[0],
        alt: 'Shield logo icon',
        price: product.variants[0].price,
        variants: product.variants,
      };
    });

    const isWarrantyChecked = ref(false);
    const toggleWarrantyCheck = () => {
      isWarrantyChecked.value = !isWarrantyChecked.value;
      if (isWarrantyChecked.value) {
        emit('warrantySelected', warranty.value);
      } else {
        emit('warrantySelected', null);
      }
    };

    return {
      isWarrantyChecked,
      toggleWarrantyCheck,
      warranty,
    };
  },
});

